const PictureOptionsGrid = ({
  options = [],
  onSelect,
  disabled = false,
  maxHeight = '320px',
}) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px',
        width: '100%',
        padding: '8px 0',
        maxHeight,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type='button'
          onClick={() => onSelect(option)}
          disabled={disabled}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            background: '#fff',
            border: '1.5px solid rgba(212,165,165,0.3)',
            borderRadius: '12px',
            padding: '6px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'border-color 0.15s, transform 0.1s',
          }}
          onMouseEnter={(event) => {
            if (disabled) return

            event.currentTarget.style.borderColor = '#a8295d'
            event.currentTarget.style.transform = 'scale(1.03)'
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.borderColor =
              'rgba(212,165,165,0.3)'
            event.currentTarget.style.transform = 'scale(1)'
          }}
        >
          <img
            src={option.image}
            alt={option.label}
            style={{
              width: '100%',
              aspectRatio: '1',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
          <span
            style={{
              fontSize: '10px',
              fontWeight: 600,
              color: '#a8295d',
              textAlign: 'center',
              lineHeight: 1.3,
            }}
          >
            {option.label}
          </span>
        </button>
      ))}
    </div>
  )
}

export default PictureOptionsGrid